import React from 'react';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import get from 'lodash/get';

class ColorInput extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {
      displayColorPicker: false,
      color: props.value
    };
  }

  handleClick() {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  }

  handleClose() {
    this.setState({ displayColorPicker: false });
  }

  handleChange(color) {
    const { onChange } = this.props;
    this.setState({ color: this.props.hex ? color.hex : color.rgb }, () => {
      onChange(this.state.color);
    });
  }

  handleReset(e) {
    e.stopPropagation();
    const { onChange } = this.props;
    this.setState({ color: null }, () => {
      onChange(this.state.color);
    });
  }

  render() {
    const r = get(this.props.value, 'r', 255);
    const b = get(this.props.value, 'b', 255);
    const g = get(this.props.value, 'g', 255);
    const a = get(this.props.value, 'a', 100);

    const backColor = this.props.hex ? this.props.value : `rgba(${r}, ${g}, ${b}, ${a})`;
    
    const styles = reactCSS({
      default: {
        color: {
          width: '100%',
          height: '30px',
          borderRadius: '2px',
          background: backColor,
          padding: 7
        },
        swatch: {
          padding: '3px',
          background: '#fff',
          borderRadius: '4px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          cursor: 'pointer',
        },
        reset: {
          float: 'right',
          position: 'relative',
          bottom: 38,
          right: 15,
          fontSize: 18,
          padding: 10
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    const defaultColor = this.props.hex ? '#ffffff' : { r: 255, b: 255, g: 255, a: 100 };

    return (
      <div>
        <div style={styles.swatch} onClick={this.handleClick.bind(this)}>
          <div style={styles.color}>
            {(this.state.color || this.props.value) ? null : 'Click to select color'}
          </div>
          <span style={styles.reset} onClick={this.handleReset.bind(this)}>
            ×
          </span>
        </div>
        {this.state.displayColorPicker ? <div style={styles.popover}>
          <div style={styles.cover} onClick={this.handleClose.bind(this)} />
          <SketchPicker 
            color={this.state.color || this.props.value || defaultColor} 
            onChange={this.handleChange.bind(this)}
          />
        </div> : null }

      </div>
    );
  }
}

export default ColorInput;
